import { LambdaChartData, SelectedIndexes, TableData, ValuesData } from "../../types";

export const INITIAL_TABLE_DATA: TableData[] = [];
export const INITIAL_SELECTED_INDEXES: SelectedIndexes = {};
export const INITIAL_VALUES_DATA: ValuesData | null = null;
export const INITIAL_CHART_DATA: LambdaChartData = {
  calculated: [],
  original: [],
  liao: []
};